// 創作記錄翻譯

export const creationRecord = {
    title: 'My Creations',
    description: 'View and manage all your AI-generated creations',
    loading: 'Loading your creations...',
    all: 'All',
    completed: 'Completed',
    processing: 'Processing',
    filterAll: 'All',
    filterImages: 'Images',
    filterVideos: 'Videos',
    filterAudio: 'Audio',
    view: 'View',
    download: 'Download',
    delete: 'Delete',
    reEdit: 'Re-edit',
    share: 'Share',
    shareToX: 'Share to X',
    shareToFacebook: 'Share to Facebook',
    enterShareText: 'Enter share text',
    useTemplate: 'Use template copy',
    templateShareText: "The ultimate AI content tool of 2025, bar none! Catoo's unified style and batch generation will elevate your content creation! Hurry!",
    credits: 'credits',
    images: 'images',
    noPreview: 'No Preview',
    confirmDelete: 'Are you sure you want to delete this creation record?',
    recordCard: {
      createdAt: 'Created at',
      downloadOriginal: 'Download Original',
      downloadProcessed: 'Download Processed',
      viewDetails: 'View Details'
    },
    emptyState: {
      noRecordsFound: 'No records found',
      noRecordsDescription: 'You haven\'t created anything yet or no records match your filter.',
      startCreating: 'Start Creating'
    },
    creationThumbnail: 'Creation thumbnail',
    noRecordsFound: 'No records found',
    noRecordsDescription: 'You haven\'t created anything yet or no records match your filter.',
    startCreating: 'Start Creating',
    types: {
      faceSwap: 'Face Pinch',
      logoGeneration: 'Logo Generation',
      idPhotoGeneration: 'ID Photo Generation',
      professionalPortrait: 'Professional Portrait',
      popArtPortrait: 'Pop Art Portrait',
      animeStyle: 'Anime Style',
      oilPainting: 'Oil Painting',
      watercolor: 'Watercolor',
      sketchStyle: 'Sketch Style',
      cyberpunk: 'Cyberpunk',
      restoredImage: 'Restored Image',
      TEXT_TO_IMAGE: 'Text to Image',
      IMAGE_TO_IMAGE: 'Image to Image',
      TEXT_TO_VIDEO: 'Text to Video',
      IMAGE_TO_VIDEO: 'Image to Video',
      REFERENCE_IMAGE_TO_VIDEO: 'Reference Image to Video',
      KEY_IMAGE_TO_VIDEO: 'Keyframe Image to Video',
      TEXT_TO_AUDIO: 'Text to Audio',
      IMAGE_TO_AUDIO: 'Image to Audio',
      LYRICS_GENERATION: 'Lyrics Generation'
    }
  };
